module.exports = __webpack_public_path__ + "assets/img/rolearms-9f86702c.png";